import image1 from './1.png';
import image2 from './2.png';
import image3 from './3.png';
import image4 from './4.png';
import image5 from './5.png';
import facebook from './facebook.png';
import instagram from './instagram.png';

export const socialsDecorationImages = [
  { image: image1, heigth: 153, width: 198 },
  { image: image2, heigth: 153, width: 198 },
  { image: image3, heigth: 153, width: 198 },
  { image: image4, heigth: 153, width: 198 },
  { image: image5, heigth: 295, width: 198 },
];
export { facebook, instagram };
